import { AfterViewInit, Directive, ElementRef, EventEmitter, Input, Output } from '@angular/core';

import { SwiperContainer } from 'swiper/element';
import { SwiperOptions } from 'swiper/types';
import { register } from 'swiper/element/bundle';

@Directive({
  selector: '[appSwiper]',
  standalone: true,
})
export class SwiperDirective implements AfterViewInit {
  @Output() readonly slideChange = new EventEmitter<number>();

  @Input() config?: SwiperOptions;

  constructor(private el: ElementRef<SwiperContainer>) {}

  ngAfterViewInit(): void {
    register();
    Object.assign(this.el.nativeElement, this.config);
    this.el.nativeElement.initialize();
    this.el.nativeElement.addEventListener('swiperslidechange', (evt: any) =>
      this.slideChange.emit(evt?.detail[0].activeIndex)
    );
  }
}
